export default __webpack_public_path__ + "0e00595cccf34ecf35757e750c2be1e3.svg";